import React from 'react';

import Tippy from '@tippyjs/react';
import { Icon } from '@ontruck/orc';

import * as http from 'utils/http';
import config from 'config';
import { statusGroup, statusObject } from 'redux/modules/journeys/constants';

const t = {
  deca: 'DeCA',
};

// Only once a driver is assigned: Jobs' "Assigned" and "Finished" tabs
export const isControlDocumentAvailable = (journeyStatus) =>
  [statusGroup.ASSIGNED, statusGroup.FINISHED].includes(statusObject[journeyStatus]);

// The journey's DeCA (every order of the journey, with the QR): the same one
// the driver app gets
export const getJourneyControlDocumentUrl = async (journeyId) => {
  const { url } = await http.get(
    `${config.BASE_URL}/v1/mercury/journeys/${journeyId}/control_document/`
  );
  return url;
};

// The DeCA restricted to one shipper order (no other shippers' orders of the
// journey): the one the shipper gets in the shipper app
export const getShipperOrderControlDocumentUrl = async (shipperOrderId, journeyId) => {
  const documents = await http.get(
    `${config.BASE_URL}/v1/shipper-app/shipper_orders/${shipperOrderId}/control_document/`
  );
  const { url } =
    (documents || []).find((doc) => Number(doc.journey_id) === Number(journeyId)) || {};
  if (!url) throw new Error('No control document for this journey');
  return url;
};

export const openControlDocument = async (getUrl, notAvailableMessage) => {
  // Open the tab synchronously within the click, so popup blockers allow it
  const newTab = window.open('', '_blank');
  try {
    const url = await getUrl();
    if (newTab) {
      newTab.location.href = url;
    } else {
      window.open(url, '_blank');
    }
  } catch (e) {
    newTab?.close();
    alert(notAvailableMessage);
  }
};

export const DecaLink = ({ onClick, color = 'black', dataE2E }) => (
  <Tippy content={t.deca} placement="bottom" theme="light">
    <span
      role="button"
      aria-label={t.deca}
      data-e2e={dataE2E}
      style={{ cursor: 'pointer', display: 'inline-flex' }}
      onClick={onClick}
    >
      <Icon glyph="document" size="2.6rem" color={color} />
    </span>
  </Tippy>
);
